var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGalleryIcon = function SvgGalleryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90.14,
    height: 88.286,
    viewBox: "0 0 90.14 88.286",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca0928;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M560.4,480.061v30.9H498.6v-61.8h22.16a27.816,27.816,0,0,1,2.119-8.829H498.6a8.855,8.855,0,0,0-8.828,8.829v61.8a8.855,8.855,0,0,0,8.828,8.829h61.8a8.855,8.855,0,0,0,8.829-8.829V488.889Zm-6.622,22.071H505.219l12.139-15.582,8.652,10.418,12.139-15.627Zm12.36-40.214a20.165,20.165,0,1,0-6.269,6.224l13.773,13.773,6.269-6.268Zm-16.774.485A11.036,11.036,0,1,1,560.4,451.367,11.04,11.04,0,0,1,549.363,462.4Z",
    transform: "translate(-489.769 -431.503)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGalleryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery-icon.704d004e.svg";
export { ForwardRef as ReactComponent };